import { render, staticRenderFns } from "./BlockDeletedCustomers.vue?vue&type=template&id=f5738642&scoped=true&"
import script from "./BlockDeletedCustomers.vue?vue&type=script&lang=js&"
export * from "./BlockDeletedCustomers.vue?vue&type=script&lang=js&"
import style0 from "./BlockDeletedCustomers.vue?vue&type=style&index=0&id=f5738642&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5738642",
  null
  
)

export default component.exports